import { render, staticRenderFns } from "./TabularMultiplication.vue?vue&type=template&id=6e156f33&scoped=true&lang=pug&"
import script from "./TabularMultiplication.vue?vue&type=script&lang=js&"
export * from "./TabularMultiplication.vue?vue&type=script&lang=js&"
import style0 from "./TabularMultiplication.vue?vue&type=style&index=0&id=6e156f33&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e156f33",
  null
  
)

export default component.exports